import { createStore } from "vuex";
import modules from "./modules";

// eslint rule is disabled while root state is empty
// eslint-disable-next-line @typescript-eslint/no-empty-interface, @typescript-eslint/no-empty-object-type
export interface RootState {}

const rootState = createStore({
    state: {},
    modules: modules,
    strict: process.env.NODE_ENV === "development"
});

export default rootState;
